import {call, put, takeLatest, takeLeading} from 'redux-saga/effects'

import {API} from '../../networking/http'
import {setItemToLocalStorage} from '../../utils/local-storage'
import {basicActions, getUpdatedLocalizations, setAppLoadingState} from './actions'

export function* setAppLoadingStateSaga() {
  yield put(basicActions.isLoading(true))
  yield call(console.log, 'app loaded')
}

export function* getUpdatedLocalizationsSaga() {
  try {
    const endpoint = 'localization/localization/wba'
    const res = (yield call(API.get, endpoint)) as {status: number; data: Record<string, Record<string, string>>}
    if (res.status === 200) {
      const {en, ua, heb, th, my, ru} = res.data as Record<string, Record<string, string> | undefined>
      setItemToLocalStorage('wba-localization-en', JSON.stringify(en))
      setItemToLocalStorage('wba-localization-ua', JSON.stringify(ua))
      setItemToLocalStorage('wba-localization-heb', JSON.stringify(heb))
      Object.entries({th, my, ru}).forEach(([lang, texts]) => {
        if (texts) {
          setItemToLocalStorage(`wba-localization-${lang}`, JSON.stringify(texts))
        }
      })
    }
  } catch (e: unknown) {
    console.log(e)
  }
}

export function* globalWatcherSaga() {
  yield takeLeading(setAppLoadingState, setAppLoadingStateSaga)
  yield takeLatest(getUpdatedLocalizations, getUpdatedLocalizationsSaga)
}
